package one.healthium.profile.navigation.update_food

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.profile.ui.food_history.models.FoodItemUiModel

class DefaultUpdateFoodComponent(
    componentContext: ComponentContext,
    override val food: FoodItemUiModel,
    private val onCloseClicked: () -> Unit,
    private val onFoodSaved: () -> Unit,
) : UpdateFoodComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }

    override fun onFoodSaved() {
        onFoodSaved.invoke()
    }
}